import React from 'react';
import { SafeHTML } from '../safe-html';
import styles from './no-data.module.scss';
export const NoData = ({ imageSrc, title, safeHTMLMessage, body, ...restProps }) => (React.createElement("div", { className: styles.noDataContainer, ...restProps },
    imageSrc && React.createElement("img", { className: styles.image, src: imageSrc, alt: "" }),
    title && React.createElement("div", { className: styles.title }, title),
    safeHTMLMessage && (React.createElement(SafeHTML, { className: styles.body, html: safeHTMLMessage })),
    body && React.createElement("div", { className: styles.body }, body)));
//# sourceMappingURL=no-data.js.map